import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "game-view-container" }
const _hoisted_2 = { class: "game-view-header" }
const _hoisted_3 = { class: "operate-buttons d-flex mx-8 mt-4" }
const _hoisted_4 = { class: "mx-4" }
const _hoisted_5 = { class: "d-flex" }

import ClassSelect from "@/components/game/ClassSelect.vue";
import {ref} from "vue";
import NewGame from "@/components/game/NewGame.vue";
import {ApiMap} from "@/api/type";
import {useApi} from "@/api/handler";
import {game} from "@/api";
import GameCards from "@/components/game/GameCards.vue";
import TeamList from "@/components/game/TeamList.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'GameView',
  setup(__props) {

const tab = ref<string>('one')
const classSelected = ref<number | null>(null)
const gameList = ref<ApiMap['/game/list/:cid']['resp'] | null>(null)
const TeamListRef = ref<InstanceType<typeof TeamList> | null>(null)

function handleSelected (id: number) {
  classSelected.value = id
  tab.value = "two"
}

function handleChange (id: number) {
  classSelected.value = id
  useGameList()
}

function handleUpdateTeamList (gameId: number) {
  TeamListRef.value.useTeamList(gameId)
}

const useGameList = () => {
  if (!classSelected.value) return
  useApi({
    api: game.GameList(classSelected.value),
    onSuccess: resp => {gameList.value = resp.data as ApiMap['/game/list/:cid']['resp']}
  })
}

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_empty_state = _resolveComponent("v-empty-state")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_tabs, {
        modelValue: tab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
        class: "ml-10",
        height: "60px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tab, {
            value: "one",
            class: "tabs-title"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("游戏管理")
            ])),
            _: 1,
            __: [2]
          }),
          _createVNode(_component_v_tab, {
            value: "two",
            class: "tabs-title"
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("游戏设置")
            ])),
            _: 1,
            __: [3]
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(_component_v_divider),
    _createVNode(_component_v_tabs_window, {
      modelValue: tab.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tab).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_tabs_window_item, { value: "one" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(ClassSelect, {
                onChange: handleChange,
                onSubmit: handleSelected
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              (!gameList.value || gameList.value.length === 0)
                ? (_openBlock(), _createBlock(_component_v_empty_state, {
                    key: 0,
                    class: "mt-12",
                    icon: "$error",
                    title: "该课程无游戏记录",
                    text: "若未选择课程请先点击左上角选择框选择课程，若已选择课程则该课程并无任何游戏保存记录"
                  }))
                : _createCommentVNode("", true),
              (gameList.value && gameList.value.length > 0)
                ? (_openBlock(), _createBlock(GameCards, {
                    key: 1,
                    color: "green-darken-1",
                    data: gameList.value
                  }, null, 8, ["data"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_v_tabs_window_item, { value: "two" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(NewGame, {
                cid: classSelected.value,
                onUpdateTeamList: handleUpdateTeamList
              }, null, 8, ["cid"]),
              _createVNode(TeamList, {
                ref_key: "TeamListRef",
                ref: TeamListRef
              }, null, 512)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})